import { Patient } from '@/models/Patient.ts';
import { SyncState } from '@/models/SyncState.ts';
import {
    CardReadActionType,
    CardReadResponseDto,
    CardReadStatus,
    CardReadValidationStatus,
    CardType,
    DCCardReader,
    VersionType,
} from '@/models/doc-cirrus/DCCardReader.ts';

import { isSalesEnvironment } from '@/utils/envUtils.ts';

export const mocked_cardreaders: DCCardReader[] = [
    {
        instance_id: 'c019c6fa-ca3c-4a6a-8a50-99e687a07e0c',
        reader_id: 'cr-001',
        terminal_id: 'terminal-001',
        tenant: {
            id: 'tenant-001',
            name: 'Empfang',
        },
        workplace: {
            id: 'workplace-001',
            name: 'Empfang',
        },
        client_system: 'EH-OFFICE-APP',
        terminals: [
            {
                id: 'terminal-001',
                name: 'Terminal 1',
            },
        ],
        cards: [
            {
                id: 'card-001',
                type: CardType.SMCB,
                versions: [
                    {
                        type: VersionType.COS,
                        major: '1',
                        minor: '0',
                        revision: '0',
                    },
                    {
                        type: VersionType.OBJECT_SYSTEM,
                        major: '2',
                        minor: '1',
                        revision: '0',
                    },
                ],
                meta: {
                    iccsn: '80276123456789',
                    terminal_id: 'terminal-001',
                    slot_id: 'slot-001',
                    card_holder_name: 'Dr. Medical Practice',
                    insertion_time: '2025-06-10T17:13:19Z',
                    certificate_expiration_date: '2027-06-30T00:00:00Z',
                },
            },
        ],
        profiles: [
            {
                label: 'Default Profile',
                terminals: ['terminal-001'],
            },
        ],
        sync_state: SyncState.UPTODATE,
        meta: {
            created_at: '2024-04-15T00:00:00Z',
            updated_at: '2025-05-10T00:00:00Z',
            synced_at: '2025-06-10T00:00:00Z',
        },
    },
    {
        instance_id: 'c019c6fa-ca3c-4a6a-8a50-99e687a07e0c',
        reader_id: 'cr-002',
        terminal_id: 'terminal-002',
        tenant: {
            id: 'tenant-001',
            name: 'Empfang',
        },
        workplace: {
            id: 'workplace-002',
            name: 'Empfang',
        },
        client_system: 'EH-OFFICE-APP',
        terminals: [
            {
                id: 'terminal-002',
                name: 'Terminal 2',
            },
            {
                id: 'terminal-003',
                name: 'Terminal 3',
            },
        ],
        cards: [
            {
                id: 'card-002',
                type: CardType.HBA,
                versions: [
                    {
                        type: VersionType.COS,
                        major: '1',
                        minor: '5',
                        revision: '2',
                    },
                    {
                        type: VersionType.ATR,
                        major: '3',
                        minor: '0',
                        revision: '1',
                    },
                ],
                meta: {
                    iccsn: '80276987654321',
                    terminal_id: 'terminal-002',
                    slot_id: 'slot-002',
                    card_holder_name: 'Dr. Jane Smith',
                    insertion_time: '2025-06-10T17:13:19Z',
                    certificate_expiration_date: '2026-12-15T00:00:00Z',
                },
            },
        ],
        profiles: [
            {
                label: 'Doctor Profile',
                terminals: ['terminal-002'],
            },
        ],
        sync_state: SyncState.UPTODATE,
        meta: {
            created_at: '2024-06-20T00:00:00Z',
            updated_at: '2025-05-25T00:00:00Z',
            synced_at: '2025-06-10T00:00:00Z',
        },
    },
];

export const sales_mocked_cardreaders: DCCardReader[] = [
    {
        instance_id: '4c44629b-7c42-45a9-a3dd-2e7a170fb7c6',
        reader_id: 'cr-001',
        terminal_id: 'terminal-001',
        tenant: {
            id: 'tenant-001',
            name: 'Empfang',
        },
        workplace: {
            id: 'workplace-001',
            name: 'Empfang',
        },
        client_system: 'EH-OFFICE-APP',
        terminals: [
            {
                id: 'terminal-001',
                name: 'Terminal 1',
            },
        ],
        cards: [
            {
                id: 'card-001',
                type: CardType.SMCB,
                versions: [
                    {
                        type: VersionType.COS,
                        major: '1',
                        minor: '0',
                        revision: '0',
                    },
                    {
                        type: VersionType.OBJECT_SYSTEM,
                        major: '2',
                        minor: '1',
                        revision: '0',
                    },
                ],
                meta: {
                    iccsn: '80276123456789',
                    terminal_id: 'terminal-001',
                    slot_id: 'slot-001',
                    card_holder_name: 'Dr. Medical Practice',
                    insertion_time: '2025-06-10T17:13:19Z',
                    certificate_expiration_date: '2027-06-30T00:00:00Z',
                },
            },
        ],
        profiles: [
            {
                label: 'Default Profile',
                terminals: ['terminal-001'],
            },
        ],
        sync_state: SyncState.UPTODATE,
        meta: {
            created_at: '2024-04-15T00:00:00Z',
            updated_at: '2025-05-10T00:00:00Z',
            synced_at: '2025-06-10T00:00:00Z',
        },
    },
    {
        instance_id: '4c44629b-7c42-45a9-a3dd-2e7a170fb7c6',
        reader_id: 'cr-002',
        terminal_id: 'terminal-002',
        tenant: {
            id: 'tenant-001',
            name: 'Empfang',
        },
        workplace: {
            id: 'workplace-002',
            name: 'Empfang',
        },
        client_system: 'EH-OFFICE-APP',
        terminals: [
            {
                id: 'terminal-002',
                name: 'Terminal 2',
            },
            {
                id: 'terminal-003',
                name: 'Terminal 3',
            },
        ],
        cards: [
            {
                id: 'card-002',
                type: CardType.HBA,
                versions: [
                    {
                        type: VersionType.COS,
                        major: '1',
                        minor: '5',
                        revision: '2',
                    },
                    {
                        type: VersionType.ATR,
                        major: '3',
                        minor: '0',
                        revision: '1',
                    },
                ],
                meta: {
                    iccsn: '80276987654321',
                    terminal_id: 'terminal-002',
                    slot_id: 'slot-002',
                    card_holder_name: 'Dr. Jane Smith',
                    insertion_time: '2025-06-10T17:13:19Z',
                    certificate_expiration_date: '2026-12-15T00:00:00Z',
                },
            },
        ],
        profiles: [
            {
                label: 'Doctor Profile',
                terminals: ['terminal-002'],
            },
        ],
        sync_state: SyncState.UPTODATE,
        meta: {
            created_at: '2024-06-20T00:00:00Z',
            updated_at: '2025-05-25T00:00:00Z',
            synced_at: '2025-06-10T00:00:00Z',
        },
    },
];

const user1: Patient = {
    instance_id: 'c019c6fa-ca3c-4a6a-8a50-99e687a07e0c',
    user_id: '69bd84a5f13d54f0670c0a5b',
    primary_email: 'anja.sonnenschein+dorydocs@eterno.health',
    name: {
        first_name: 'Dory',
        middle_name: '',
        last_name: 'Docs',
        salutation: 'NONE',
        gender: 'UNKNOWN',
    },
    account: {
        date_of_birth: '1999-09-09T00:00:00.000Z',
        active_case_folder_id: '69bd84a5f13d54f0670c0a68',
        patient_number: '22952',
    },
    contact: {
        emails: ['anja.sonnenschein+dorydocs@eterno.health'],
    },
    addresses: [
        {
            id: '69bd84a5f13d54f0670c0a5c',
            type: 'OFFICIAL',
            street: 'Sonnenallee',
            house_number: '1',
            city: 'Berlin',
            zip: '12043',
            country: 'Deutschland',
            country_code: 'DE',
        },
    ],
    communications: [
        {
            id: '69bd84a5f13d54f0670c0a5d',
            type: 'EMAILJOB',
            value: 'anja.sonnenschein+dorydocs@eterno.health',
            preferred: true,
            confirmed: false,
            confirmation_needed: false,
        },
        {
            id: '69bd84a5f13d54f0670c0a5e',
            type: 'MOBILEPRIV',
            value: '+4917644271793',
            confirmed: false,
            confirmation_needed: false,
        },
    ],
    insurances: [
        {
            id: '69bd84a5f13d54f0670c0a5f',
            type: 'PUBLIC',
            name: 'DUMMY',
            insurance_print_name: '',
            company_id: '000000000',
            number: '',
            membership_type: '5',
            ktab: '01',
            group_id: '00',
            fee_schedule: '1',
            expiry_date: '',
            location_id: '611ce17d704edc2ca1176df1',
            card_swipe_date: '',
        },
        {
            id: '69be5cfa312e6f658eefbbdd',
            type: 'PRIVATE',
            name: 'DUMMY',
            insurance_print_name: '',
            company_id: '',
            number: '',
            membership_type: '',
            ktab: '',
            group_id: '',
            fee_schedule: '1',
            expiry_date: '',
            location_id: '611ce17d704edc2ca1176df1',
            card_swipe_date: '',
        },
    ],
    other_locations: {
        is_access_enabled: false,
        ids: [],
    },
    is_data_admission_to_pvs_approved: true,
    sync_state: 'UPTODATE',
    meta: {
        created_at: '2026-03-20T17:32:21.000Z',
        updated_at: '2026-03-21T09:30:19.154Z',
        synced_at: '2026-03-21T09:30:17.350Z',
    },
    is_registered: false,
};

const user2: Patient = {
    instance_id: 'c019c6fa-ca3c-4a6a-8a50-99e687a07e0c',
    user_id: '69bd8438f13d54f0670c0a24',
    primary_email: 'anja.sonnenschein+dasydata@eterno.health',
    name: {
        first_name: 'Dasy',
        middle_name: '',
        last_name: 'Data',
        salutation: 'NONE',
        gender: 'UNKNOWN',
    },
    account: {
        date_of_birth: '1999-09-09T00:00:00.000Z',
        active_case_folder_id: '69bd8438f13d54f0670c0a31',
        patient_number: '22951',
    },
    contact: {
        emails: ['anja.sonnenschein+dasydata@eterno.health'],
    },
    addresses: [
        {
            id: '69bd8438f13d54f0670c0a25',
            type: 'OFFICIAL',
            street: 'Alexanderplatz',
            house_number: '1',
            city: 'Berlin',
            zip: '12345',
            country: 'Deutschland',
            country_code: 'DE',
        },
    ],
    communications: [
        {
            id: '69bd8438f13d54f0670c0a26',
            type: 'EMAILJOB',
            value: 'anja.sonnenschein+dasydata@eterno.health',
            preferred: true,
            confirmed: false,
            confirmation_needed: false,
        },
        {
            id: '69bd8438f13d54f0670c0a27',
            type: 'MOBILEPRIV',
            value: '+4917644271793',
            confirmed: false,
            confirmation_needed: false,
        },
    ],
    insurances: [
        {
            id: '69bd8438f13d54f0670c0a28',
            type: 'PUBLIC',
            name: 'DUMMY',
            insurance_print_name: '',
            company_id: '000000000',
            number: '',
            membership_type: '5',
            ktab: '01',
            group_id: '00',
            fee_schedule: '1',
            expiry_date: '',
            location_id: '611ce17d704edc2ca1176df1',
            card_swipe_date: '',
        },
    ],
    other_locations: {
        is_access_enabled: false,
        ids: [],
    },
    is_data_admission_to_pvs_approved: true,
    sync_state: 'UPTODATE',
    meta: {
        created_at: '2026-03-20T17:30:32.000Z',
        updated_at: '2026-03-20T17:30:34.444Z',
        synced_at: '2026-03-20T17:30:34.444Z',
    },
    is_registered: false,
};

const sales_user1: Patient = {
    instance_id: '4c44629b-7c42-45a9-a3dd-2e7a170fb7c6',
    user_id: '67bf31eaf80cbf363698cb1c',
    primary_email: 'max.mustermann@eterno.health',
    name: {
        first_name: 'Max',
        middle_name: '',
        last_name: 'Mustermann',
        salutation: 'NONE',
        gender: 'UNKNOWN',
    },
    account: {
        date_of_birth: '1990-01-01T00:00:00.000Z',
        active_case_folder_id: '67fce55ff4f26b4c1e33bc5f',
        patient_number: '93',
    },
    contact: {
        emails: ['max.mustermann@eterno.health'],
    },
    addresses: [
        {
            id: '67bf31eaf80cbf363698cb1d',
            type: 'OFFICIAL',
            street: 'Unter den Linden 4',
            house_number: '',
            city: 'Berlin',
            zip: '10117',
            country: 'Germany',
            country_code: 'DE',
        },
    ],
    communications: [
        {
            id: '67bf31eaf80cbf363698cb1e',
            type: 'EMAILJOB',
            value: 'max.mustermann@eterno.health',
            preferred: true,
            confirmed: false,
            confirmation_needed: false,
        },
        {
            id: '67bf31eaf80cbf363698cb1f',
            type: 'MOBILEPRIV',
            value: '+4917658214215',
            confirmed: false,
            confirmation_needed: false,
        },
    ],
    insurances: [
        {
            id: '67fce55ff4f26b4c1e33bc57',
            type: 'SELFPAYER',
            name: '',
            insurance_print_name: '',
            company_id: '',
            number: '',
            membership_type: '',
            ktab: '',
            group_id: '',
            fee_schedule: '',
            expiry_date: '',
            location_id: '66e959b2e17528b3a08ca47e',
            card_swipe_date: '',
        },
    ],
    other_locations: {
        is_access_enabled: false,
        ids: [],
    },
    is_data_admission_to_pvs_approved: false,
    sync_state: 'UPTODATE',
    meta: {
        created_at: '2025-02-26T15:23:22.000Z',
        updated_at: '2025-11-26T17:20:03.176Z',
        synced_at: '2025-11-26T17:20:03.176Z',
    },
    is_registered: false,
};

const sales_user2: Patient = {
    instance_id: '4c44629b-7c42-45a9-a3dd-2e7a170fb7c6',
    user_id: '686f7ec966b02dc00e55e2fc',
    primary_email: 'test@test.de',
    name: {
        first_name: 'Sophia',
        middle_name: '',
        last_name: 'Musterfrau',
        salutation: 'MS',
        gender: 'FEMALE',
    },
    account: {
        date_of_birth: '2000-01-01T09:00:00.000Z',
        active_case_folder_id: '686f7ec966b02dc00e55e308',
        patient_number: '372',
    },
    contact: {
        emails: ['test@test.de'],
    },
    addresses: [
        {
            id: '686f7ec966b02dc00e55e2fd',
            type: 'OFFICIAL',
            street: '',
            house_number: '',
            city: 'Berlin',
            zip: '10179',
            country: 'Deutschland',
            country_code: 'DE',
        },
    ],
    communications: [
        {
            id: '686f7ec966b02dc00e55e2fe',
            type: 'EMAILPRIV',
            value: 'test@test.de',
            confirmed: false,
            confirmation_needed: false,
        },
    ],
    insurances: [
        {
            id: '686f7ec966b02dc00e55e2ff',
            type: 'SELFPAYER',
            name: '',
            insurance_print_name: '',
            company_id: '',
            number: '',
            membership_type: '',
            ktab: '',
            group_id: '',
            fee_schedule: '',
            expiry_date: '',
            location_id: '66e959b2e17528b3a08ca47e',
            card_swipe_date: '',
        },
    ],
    other_locations: {
        is_access_enabled: false,
        ids: [],
    },
    is_data_admission_to_pvs_approved: true,
    sync_state: 'UPTODATE',
    meta: {
        created_at: '2025-07-10T08:50:17.000Z',
        updated_at: '2025-11-26T17:20:03.179Z',
        synced_at: '2025-11-26T17:20:03.179Z',
    },
    is_registered: false,
};

export const getMockedResponse = (status: CardReadStatus, user_id?: string): CardReadResponseDto => {
    const is_sales_environment = isSalesEnvironment();
    if (user_id) {
        const key = `${status}::${user_id}`;
        return is_sales_environment ? sales_mocked_responses[key] : mocked_responses[key];
    }

    return is_sales_environment ? sales_mocked_responses[status] : mocked_responses[status];
};

const mocked_responses: Record<string, CardReadResponseDto> = {
    [`${CardReadStatus.APPLIED}::${user1.user_id}`]: {
        op_id: '79888cd8-98dc-4f49-9b52-dc35e3fb2ef7',
        status: CardReadStatus.APPLIED,
        validation_status: CardReadValidationStatus.OK,
        possible_actions: [],
        matched_patients: [user1.user_id],
    },
    [`${CardReadStatus.APPLIED}::${user2.user_id}`]: {
        op_id: '79888cd8-98dc-4f49-9b52-dc35e3fb2ef7',
        status: CardReadStatus.APPLIED,
        validation_status: CardReadValidationStatus.OK,
        possible_actions: [],
        matched_patients: [user2.user_id],
    },
    [CardReadStatus.APPLIED]: {
        op_id: '79888cd8-98dc-4f49-9b52-dc35e3fb2ef7',
        status: CardReadStatus.APPLIED,
        validation_status: CardReadValidationStatus.OK,
        possible_actions: [],
        matched_patients: [user1.user_id],
    },
    [CardReadStatus.MATCHING]: {
        op_id: '5de4db73-e9b7-4ee0-b4aa-0611a0b1000a',
        status: CardReadStatus.MATCHING,
        validation_status: CardReadValidationStatus.OK,
        possible_actions: [CardReadActionType.CANCEL, CardReadActionType.MATCHING_SELECT],
        matched_patients: [user1.user_id, user2.user_id],
    },
    [CardReadStatus.MERGED]: {
        op_id: '0833611e-0291-402f-9833-0215c748c5bb',
        status: CardReadStatus.MERGED,
        validation_status: CardReadValidationStatus.OK,
        possible_actions: [CardReadActionType.CANCEL, CardReadActionType.APPLY],
        matched_patients: [user1.user_id],
        diff_fields: [
            {
                label: 'Straße',
                old_value: 'Sonnenallee 1',
                new_value: 'Marienplatz 8',
            },
            {
                label: 'PLZ',
                old_value: '12043',
                new_value: '80331',
            },
            {
                label: 'Stadt',
                old_value: 'Berlin',
                new_value: 'München',
            },
        ],
    },
    [CardReadStatus.CANCELLED]: {
        op_id: '4e70bfe7-ed97-4005-b44f-9478da9bad47',
        status: CardReadStatus.CANCELLED,
        validation_status: CardReadValidationStatus.OK,
        possible_actions: [],
        matched_patients: [],
    },
};

export const sales_mocked_responses: Record<string, CardReadResponseDto> = {
    [`${CardReadStatus.APPLIED}::${sales_user1.user_id}`]: {
        op_id: '79888cd8-98dc-4f49-9b52-dc35e3fb2ef7',
        status: CardReadStatus.APPLIED,
        validation_status: CardReadValidationStatus.OK,
        possible_actions: [],
        matched_patients: [sales_user1.user_id],
    },
    [`${CardReadStatus.APPLIED}::${sales_user2.user_id}`]: {
        op_id: '79888cd8-98dc-4f49-9b52-dc35e3fb2ef7',
        status: CardReadStatus.APPLIED,
        validation_status: CardReadValidationStatus.OK,
        possible_actions: [],
        matched_patients: [sales_user2.user_id],
    },
    [CardReadStatus.APPLIED]: {
        op_id: '79888cd8-98dc-4f49-9b52-dc35e3fb2ef7',
        status: CardReadStatus.APPLIED,
        validation_status: CardReadValidationStatus.OK,
        possible_actions: [],
        matched_patients: [sales_user1.user_id],
    },
    [CardReadStatus.MATCHING]: {
        op_id: '5de4db73-e9b7-4ee0-b4aa-0611a0b1000a',
        status: CardReadStatus.MATCHING,
        validation_status: CardReadValidationStatus.OK,
        possible_actions: [CardReadActionType.CANCEL, CardReadActionType.MATCHING_SELECT],
        matched_patients: [sales_user1.user_id, sales_user2.user_id],
    },
    [CardReadStatus.MERGED]: {
        op_id: '0833611e-0291-402f-9833-0215c748c5bb',
        status: CardReadStatus.MERGED,
        validation_status: CardReadValidationStatus.OK,
        possible_actions: [CardReadActionType.CANCEL, CardReadActionType.APPLY],
        matched_patients: [sales_user1.user_id],
        diff_fields: [
            {
                label: 'Vorname',
                old_value: 'Test',
                new_value: 'Test2',
            },
            {
                label: 'Nachname',
                old_value: 'Test3',
                new_value: 'Test4',
            },
            {
                label: 'Versicherten-Nr.',
                old_value: '1150',
                new_value: '1151',
            },
        ],
    },
    [CardReadStatus.CANCELLED]: {
        op_id: '4e70bfe7-ed97-4005-b44f-9478da9bad47',
        status: CardReadStatus.CANCELLED,
        validation_status: CardReadValidationStatus.OK,
        possible_actions: [],
        matched_patients: [],
    },
};
